/*global FB*/
import React from 'react';
import Dialog from 'material-ui/Dialog';
import Toggle from 'material-ui/Toggle';
import {apiService} from "../common/apiCallService"
import Checkbox from 'material-ui/Checkbox';
import FlatButton from 'material-ui/FlatButton';
import {baseUrl} from '../common/config.js';
import TwitterLogin from 'react-twitter-auth'
import Loading from './Loading.js';
import moment from 'moment';

/*
props = {
  open : boolean
  onRequestClose : function
  title : String
  type : String
  message : String
  link : String
  image : String
  shareParams : {
    data : Object,
    type : String
  }
  
}

# Payload Schema #
payload : {
  type : String[image, link]
  content : String
  image : base64
  link : string
  sm_list : Object
}
shareParams : {
  data : Object,
  type : String
}
*/

const initialState = {
  content : "",
  contentValid : true,
  sm_list : {
    facebook : false,
    twitter : false
  },
  payload : {},
  linkDialogOpen : false,
  linkDialogName : '',
  loading : false,
  closingDialog : false,
  shareResponse : [],
  closingDialogText : 'Share successfully'
}

export default class ShareDialog extends React.Component {
  constructor(props) {
    super(props)
    this.state = initialState
  }
  
  static defaultProps = {
    promotionalUrl: '',
    title : 'Share',
    shareParams : {},
    message : '',
    link : '',
    image : ''
  };
  
  componentWillReceiveProps(nextProps) {
    this.loadPropsToState(this.props);
  }
  
  loadPropsToState = (props) => {
    this.setState({content : props.message})
  }

  getLinkedStatus = (sm_name, success) => {
    apiService(
      baseUrl+'/publish/linkstatus',
      {sm_name},
      data => success(data.linkstatus),
      err => console.log(err)
    )
  }

  onCheckBoxChange = (event) => {
    const sm_name = event.target.id;
    let {sm_list} = this.state;
    if(!sm_list[sm_name]) {
      let loading = true;
      this.setState({loading})
      this.getLinkedStatus(sm_name,
        linkstatus => {
          sm_list[sm_name] = linkstatus;
          loading = false;
          this.setState({sm_list , loading})
          if(!linkstatus) this.openLinkDialog(sm_name);
        }
      );
    } else {
      sm_list[sm_name] = false;
      this.setState({sm_list})
    }
  }
  
  openLinkDialog = (sm_name) => {
    let {linkDialogOpen, linkDialogName} = this.state;
    linkDialogOpen = true;
    linkDialogName = sm_name;
    this.setState({linkDialogOpen, linkDialogName});
  }

  closeLinkDialog = (sm_name) => {
    let {linkDialogOpen, linkDialogName} = this.state;
    linkDialogOpen = false;
    linkDialogName = '';
    this.setState({linkDialogOpen, linkDialogName});
  }

  getLinkDialogActions = (sm_name) => {
    const actions = [];
    const noButton = <FlatButton label="No" primary={true} onClick={this.closeLinkDialog}/>;
    const facebook = <FlatButton label="Link to Facebook" primary={true} onClick={this.facebookLogin}/>;
    const twitter = <TwitterLogin
                      loginUrl={baseUrl+"/twitter/authenticate"}
                      onFailure={data => {
                        this.closeLinkDialog();
                      }}
                      onSuccess={err => {
                        let {sm_list} = this.state;
                        sm_list.twitter = true;
                        this.setState({sm_list},this.closeLinkDialog())
                      }}
                      requestTokenUrl={baseUrl+"/twitter/reverse"}
                      text = {`link to twitter`}
                      customHeaders={{token : localStorage.getItem('token')}}
                      showIcon={true}/>

    actions.push(noButton);

    if(sm_name == '') actions.push(noButton)
    else if(sm_name == 'facebook') actions.push(facebook)
    else if(sm_name == 'twitter') actions.push(twitter)

    return actions;
  }

  addToActivityTrack = (sm_list) => {
    let {trackData} = this.props;
    let activityTrack =[]
    if(localStorage.getItem('activityTrack'))
        activityTrack=JSON.parse(localStorage.getItem('activityTrack'))
    trackData.hit_timestamp=moment().format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
    trackData.hit_attribute1 = this.getSmListAsString(sm_list);
    console.log(trackData);
    activityTrack.push(trackData)
    localStorage.setItem('activityTrack',JSON.stringify(activityTrack))
  }

  getSmListAsString = (sm_list) => {
    let sm_array = [];
    for(const sm in sm_list) if(sm_list[sm]) sm_array.push(sm);
    return sm_array.toString().replace(',','/');
  }

  onShare = () => {
    this.setState({loading : true})
    const {sm_list, content} = this.state;
    this.addToActivityTrack(sm_list);
    const {
      type,
      image,
      link,
      shareParams,
    } = this.props;
    const payload = {
      type,
      image,
      link,
      sm_list, 
      content
    };
    // this.setState({
    //   loading : false,
    //   closingDialog : true,
    //   shareResponse : [
    //     {
    //       sm_name : 'facebook',
    //       type : 'image',
    //       status : 'done',
    //     },
    //     {
    //       sm_name : 'twitter',
    //       type : 'image',
    //       status : 'error',
    //     }
    //   ]
    // });
    apiService(
      baseUrl + '/publish/share',
      {
        payload,
        shareParams
      },
      res => {
        // console.log(res);
        this.setState({
          loading : false,
          closingDialog : true,
          shareResponse : res
        });
      },
      err => {
        console.log(err);
        alert('Something Went Wrong')
        this.handleClose();
      }
    )
  }
  validateContentLength = () => {
    let {sm_list,content, contentValid} = this.state;
    if(sm_list.twitter == true && content.length > 180) return false;
    else return true;
  }

  facebookLogin = () => {
    let {sm_list} = this.state;
    FB.login(response => {
      if(this.validateFacebookScope(response)) {
        apiService(
          baseUrl + '/facebook/authenticate',
          {access_token : response.authResponse.accessToken},
          data => {
            sm_list.facebook = true;
            this.setState({sm_list},this.closeLinkDialog())
          },
          err => this.closeLinkDialog()
        )
      } else this.closeLinkDialog()
    }, {scope: 'publish_actions,public_profile', return_scopes: true})
  }

  validateFacebookScope = (response) => {
    let index = response
      .authResponse
      .grantedScopes
      .split(",")
      .findIndex(permission => permission == "publish_actions")
      if(response.status == "connected" && index != -1) return true;
      else return false;
  }

  handleClose = () => {
    this.setState(initialState,this.props.onRequestClose)
    // this.props.onRequestClose();
  }

  isShareDisabbled = () => {
    const {sm_list, contentValid} = this.state;
    let c = 0;
    for(let sm in this.state.sm_list) if(this.state.sm_list[sm]) c++
    return c==0 || !this.validateContentLength();
  }

  onContentChange = (event) => {
    let {content} = this.state;
    content = event.target.value;
    this.setState({content})
  }
  getShareStatus = (shareResult) => {
    let msg = '';
    let errArray = shareResult.filter(result => result.status != 'done')
    if( errArray.length == 0 ) msg = 'Shared Successfully';
    else {
      shareResult.map(op => {
        if(op.status == 'done') msg = `Shared Successfully on ${op.sm_name}. ${msg}`;
        else msg = `${msg}. Error occured while Sharing on ${op.sm_name}. `
      })
    }
    return <div>{msg}</div>
    // if(shareResult.status == 'done') return <div>your message successfully shared on {shareResult.sm_name}<hr/></div>
    // else return <div>Something went wrong while sharing on {shareResult.sm_name}<hr/></div>
  }
  
  
  render() {
    // this.loadPropsToState(this.props);
    const actions = [
      <FlatButton
        label="Cancel"
        primary={true}
        onClick={this.handleClose}
      />,
      <FlatButton
        label="Share"
        primary={true}
        disabled= {this.isShareDisabbled()}
        onClick={this.onShare}
      />,
    ];
    return(
      <div>

      <Dialog
        contentStyle = {{width:300,maxWidth: 'none'}}
        title={this.props.title}
        actions ={actions}
        modal={true}
        open={this.props.open}
        onRequestClose={this.handleClose}
        autoScrollBodyContent={true}
      >

        <div>
        {this.state.loading ? <Loading/> : null}
          <Dialog
            contentStyle = {{width:300,maxWidth: 'none'}}
            actions = {this.getLinkDialogActions(this.state.linkDialogName)}
            modal = {true}
            open = {this.state.linkDialogOpen}
            onRequestClose = {() => this.setState({linkDialogOpen:false})}
          >
            Do you want to Link your {this.state.linkDialogName} account?
          </Dialog>
          <Dialog
            contentStyle = {{width:300,maxWidth: 'none'}}
            actions = {(<FlatButton
              label="Okay"
              primary={true}
              onClick={this.handleClose}
            />)}
            modal = {true}
            open = {this.state.closingDialog}
            onRequestClose = {() => this.setState({closingDialog:false})}
          >
              {this.getShareStatus(this.state.shareResponse)}
          </Dialog>
          <textarea
            style={{height: '150', width:'100%',backgroundColor:'#2D2C34',border:'none',color:'white',padding:'16px'}}
            placeholder="Message"
            value = {this.state.content}
            errorText = {""}
            multiLine={true}
            rows={1}
            rowMax={4}
            onChange = {this.onContentChange}
          />
          <hr/>
          {this.validateContentLength() ? null : <p style = {{color : 'red', fontSize: "75%"}}>{`Content length should be less than 180 characters for Twitter`}</p>}
          <div style={{width:"100%", paddingTop : "25px"}}>
            <Checkbox
              id = 'facebook'
              label="Facebook"
              checked={this.state.sm_list.facebook}
              onCheck={this.onCheckBoxChange}
            />
            <Checkbox
              id = 'twitter'
              label="Twitter"
              checked={this.state.sm_list.twitter}
              onCheck={this.onCheckBoxChange}
            />
          </div>
        </div>
      </Dialog>
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/ShareDialog.js
 **/